/**
 * A busca do seletor de contexto.
 *
 * Mora fora do componente de propósito: é o único ponto que conhece o critério de casamento,
 * e é ele que muda no dia em que a lista deixar de vir inteira no manifesto e passar a ser
 * perguntada ao servidor — sem redesenhar o modal.
 */

import type { ContextoDisponivel } from '../types/manifesto';

/** Buscar por "diagnostica" tem de achar "Diagnóstica": acento não é filtro. */
const normalizar = (texto: string) =>
  texto
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

const digitosDe = (texto: string) => texto.replace(/\D/g, '');

/** Busca escrita só com dígitos e pontuação de documento — é como se digita um CNPJ. */
const PARECE_DOCUMENTO = /^[\d.\-/\s]+$/;

/** Abaixo disso o documento casa com meio mundo e a lista não encolhe. */
const DIGITOS_MINIMOS = 3;

/**
 * O que a pessoa enxerga no item: o nome e a linha de apoio, que é onde vem o CNPJ da empresa.
 * Documento digitado sem pontuação também casa — ninguém decora os pontos e as barras.
 */
function casaComABusca(contexto: ContextoDisponivel, busca: string): boolean {
  const visivel = `${contexto.nome} ${contexto.detalhe ?? ''}`;
  if (normalizar(visivel).includes(normalizar(busca))) return true;

  const digitados = digitosDe(busca);
  if (!PARECE_DOCUMENTO.test(busca) || digitados.length < DIGITOS_MINIMOS) return false;

  return digitosDe(visivel).includes(digitados);
}

/** Sem nada digitado a lista é a completa: a busca filtra, não substitui. */
export function filtrarContextos(
  contextos: readonly ContextoDisponivel[],
  busca: string
): ContextoDisponivel[] {
  if (!busca.trim()) return [...contextos];

  return contextos.filter((contexto) => casaComABusca(contexto, busca));
}
